import React, { Component } from 'react';
import {localization} from '../../Frames/localization'
import JsBarcode from 'jsbarcode';

import {messageWindow} from '../../Elements/Snackbar/MessageWindow'

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Label from '../../Elements/Label/labels'
import SelectCard from '../../Elements/Select/selectCard'
import SelectCategory from '../../Elements/Select/selectCategory'
import Diagram from '../../Elements/Diagram/diagrams'

import TableAcCounters from '../../Elements/Table/tablesAcCounters'
import TableDiscounts from '../../Elements/Table/tableDiscounts'
import TablePurchaseAmount from '../../Elements/Table/tablePurchaseAmount'
import TablePurchaseAmountIsCompany from '../../Elements/Table/tablePurchaseAmountIsCompany'
import TableWalletbalances from '../../Elements/Table/tableWalletbalances'
import TableSeasoned from '../../Elements/Table/tableSeasoned'
import TableFundsHistory from '../../Elements/Table/tableFundsHistory'
import TableFuelHistory from '../../Elements/Table/tableFuelHistory'
//DialogWindow
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import Divider from '@material-ui/core/Divider';
import CloseIcon from '@material-ui/icons/Close';

import Button from "../../Elements/Button/buttons"; 
import FormDialog from '../../Elements/AlertWindows/formDialog'
import {themeColorText,materialThemeField} from '../../../src/App'
import { ThemeProvider } from "@material-ui/styles";

import {convert} from '../../Frames/convert'

import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

const requestOptionsExit = {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify("")}
class Bonus extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="bonusBox">
                <Label textLabel={localization.GetTranslate('Statistics.Bonus')} className="bonusLabel"></Label>
                <Tooltip title={"1 бонус = 0,01 грн"} >
                      <HelpOutlineIcon style={{color: "grey", fontSize: 20, position: "absolute",marginTop: -5, cursor: "pointer"}}></HelpOutlineIcon>
                </Tooltip>
                <Label style={{color: themeColorText.color}} textLabel={data.regularBonusTotal.pointsAmount} className="bonusValueLabel"></Label>
            </Paper>
        );
    }
}
class BonusByRecallRule extends Component
{
    render()
    {
        const{data} = this.props.res;
        const listItems = data.recallRulesName.map((listItem,index) =>
            <Grid item xs={"auto"}><Paper className="bonusBox">
                <Label key={index} textLabel={listItem} className="bonusLabel"></Label>
                <Label style={{color: themeColorText.color}} textLabel={data.bonusesByRecallRules[index]} className="bonusValueLabel"></Label>
            </Paper></Grid>
          );
        return(
                  <Grid container justify="center" spacing={3}>{listItems}</Grid>


        );
    }
}
class PromoCodesList extends Component 
{
    constructor(props)
    {
        super(props);
        this.state = {
            promoList: null,
            progress: false,
       };      
    }
    async componentDidMount() 
    {
        JsBarcode(".barcode").init();
        this.setState({progress: true})
        const requestOptionsExit = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                clientId: "6599"
            })
        }
        await fetch(`/api/getpromolist`, requestOptionsExit)
        .then((response) => {
            if(response.status == 500)
            {
                messageWindow.OpenMessage("error", "Error: "+response.status +" "+ response.statusText)
                this.setState({promoList: null})
            }
             return response.json()})
        .then((response) => {
            if(response.error !== null)
            {
                messageWindow.OpenMessage("error", "Error: "+response.error)
            }
            this.setState({promoList: response.data})
        })
        this.setState({progress: false})
    }
    render()
    {
        JsBarcode(".barcode").init();
        const {promoList, progress} = this.state;
        const {ThemeClickElements} = this.props;
        console.log(promoList)
        return(
            <ThemeProvider theme={ThemeClickElements}>
                {progress &&
                    <div className="preloaderTab"></div> 
                }
                <Grid container justify="center" spacing={4}>
                     <Grid item xs={"auto"}>
                     {/* <Paper className="PaperPromo">
                    <Grid container spacing={1}>
                        <Grid style={{padding: 12}} item xs>
                            <Label textLabel={"he entire Pro Git book, written by Scott Chacon and Ben Straub and published by Apress, is available here. All content is licensed under the Creative Commons Attribution Non Commercial Share Alike 3.0 license."} className="PromoCodeListLabel"></Label>  
                        </Grid>
                    </Grid>
                    <Divider style={{background: '#e0e0e0'}} flexItem />
                    <Grid container spacing={1}>
                        <Grid item style={{minWidth: 210, margin: 'auto'}}>
                            <div>      
                                <svg className="barcode" jsbarcode-format={"CODE128"} jsbarcode-value={576210} jsbarcode-textmargin="0" jsbarcode-height="30" jsbarcode-fontoptions="bold"/>     
                            </div>
                        </Grid>
                    </Grid>
                    <Divider style={{background: '#e0e0e0'}} flexItem />
                    <Grid container spacing={1}>
                        <Grid style={{padding: 12}} item xs>
                            <Grid container spacing={0}>
                                <Grid style={{textAlign: 'left'}} item xs>
                                    <Label textLabel={`Период действия: 05.01.2022 12:17:15 - 05.01.2022 12:17:15}`} className="PromoCodeListLabel-left"></Label>
                                </Grid>
                                <Grid style={{textAlign: 'right'}} item xs={3.5}>
                                    <Label textLabel={"Тип: Многоразовый (доступно 3)"} className="PromoCodeListLabel-right"></Label>    
                                </Grid>
                            </Grid>
                        </Grid>
                        
                    </Grid>
                </Paper>
                <br></br> */}
                {promoList &&
                <React.Fragment>
                {promoList.length === 0 &&
                <Paper className="PaperPromo">
                    <Grid container spacing={1}>
                        <Grid style={{padding: 12}} item xs>
                            <div className="SubTabNotAvailable">
                            <Grid container justify="center" spacing={3}>
                                <Grid item xs={"auto"}>
                                    <br></br>
                                        <Label textLabel={localization.GT('Statistics.No promo code')} className="LabelNotAvailable"></Label>
                                </Grid>
                            </Grid>
                            </div>
                        </Grid>
                    </Grid>
                </Paper>
                } 
                {promoList.map((promo) => {
                if(promo.useLimit > 0) 
                {
                    if(promo.useLimit - promo.useCounter === 0) return null;
                }
                return (<React.Fragment>
                <Paper className="PaperPromo">
                    {promo.description &&
                    <React.Fragment>
                        <Grid container spacing={1}>
                            <Grid style={{padding: 12}} item xs>
                                <Label textLabel={promo.description} className="PromoCodeListLabel"></Label>  
                            </Grid>
                        </Grid>
                        <Divider style={{background: '#e0e0e0'}} flexItem />
                    </React.Fragment>
                    }
                    <Grid container spacing={1}>
                        <Grid item style={{minWidth: 210, margin: 'auto'}}>
                            <div>      
                                <svg className="barcode" jsbarcode-format={"CODE128"} jsbarcode-value={promo.code} jsbarcode-textmargin="0" jsbarcode-height="30" jsbarcode-fontoptions="bold"/>     
                            </div>
                        </Grid>
                    </Grid>
                    <Divider style={{background: '#e0e0e0'}} flexItem />
                    <Grid container spacing={1}>
                        <Grid style={{padding: 12}} item xs>
                            <Grid container spacing={1}>
                                <Grid style={{textAlign: 'left'}} item xs>
                                    <Label textLabel={`${localization.GT('Statistics.Validity')}: ${convert.timestampToDateTimeStr(promo.beginDate)} - ${convert.timestampToDateTimeStr(promo.endDate)}`} className="PromoCodeListLabel-left"></Label>
                                </Grid>
                                <Grid style={{textAlign: 'right'}} item xs={3.5}>
                                    {promo.useLimit === 1 &&
                                        <Label textLabel={`${localization.GT('Statistics.Type')}: ${localization.GT('Statistics.Disposable')}`} className="PromoCodeListLabel-right"></Label>    
                                    }
                                    {promo.useLimit > 1 &&
                                        <Label textLabel={`${localization.GT('Statistics.Type')}: ${localization.GT('Statistics.Reusable')} (${localization.GT('Statistics.Available')} ${promo.useLimit - promo.useCounter})`} className="PromoCodeListLabel-right"></Label>    
                                    }
                                    {promo.useLimit === 0 &&
                                        <Label textLabel={`${localization.GT('Statistics.Type')}: ${localization.GT('Statistics.Reusable')}`} className="PromoCodeListLabel-right"></Label>    
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                        
                    </Grid>
                </Paper>
                <br></br>
                </React.Fragment>)
                })}
                </React.Fragment>
                }
                </Grid>
            </Grid>
        </ThemeProvider>
        );
    }
}
class DefaultCard extends Component 
{    
    render()
    {
        const{data} = this.props.res;
        var dataSelect = data.clientData.cards;
        var barcode = data.BarCode;
        return(
            <ThemeProvider theme={materialThemeField}>
            <Paper className="defaultcardBox">
                <Label textLabel={localization.GetTranslate('Statistics.Default card')} className="defaultcardLabel"></Label>
                <SelectCard style={{color: themeColorText.color}} dataSelect={dataSelect} value={barcode} className="defaultcardValueLabel" onSelectCard={this.props.onSelectCard}></SelectCard>
            </Paper>
            </ThemeProvider>
        );
    }
}


class CardCategory extends Component 
{ 
    constructor(props) {
    super(props); 
    this.state = {
        open: false,
        openDialog: false,
    }
    this.confirmWindowChangeCategory = this.confirmWindowChangeCategory.bind(this);
    this.confirmChangeCategoryClose = this.confirmChangeCategoryClose.bind(this);
    this.ComparisonCode = this.ComparisonCode.bind(this);
    this.handleOpen = this.handleOpen.bind(this)
     this.handleClose = this.handleClose.bind(this)
}
onChangetextField(event) {
    this.setState({textField: event.target.value});
  }
confirmWindowChangeCategory(){
        //this.ChangeParamCategory()
        var param = this.props.param;
        //var param  = this.state.param;
        if(param === "defaultCardCategory" | param === undefined)
        {
            messageWindow.OpenMessage("info", localization.GetTranslate('Statistics.categoryError'))
            this.setState({key: Math.random()})
            this.props.OpenMessage()
            return;
        }
        const{data} = this.props.res;
        if(data.clientHasNumber){
        var request = {
                text: ""
            }
        const requestData = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(request)}
        fetch(`/api/setconfirmcode`, requestData)
        .then((response) => response.json())
        .then((response) => {
                if(response.data.cancelled == null){
                    messageWindow.OpenMessage("warning", localization.GetTranslate('Statistics.CanceledCode'))
                }
                else
                {
                    messageWindow.OpenMessage("info", localization.GetTranslate('Statistics.SendSMS'))
                }
                this.setState({key: Math.random(),open: true})
                this.props.OpenMessage()
        })
        }else{
            messageWindow.OpenMessage("warning", localization.GetTranslate('Statistics.unknownPhone'))
            
            this.setState({selected:"selected", key: Math.random()})
            this.props.OpenMessage()
        }
      };
      confirmChangeCategoryClose = () => {
        messageWindow.OpenMessage("info", localization.GetTranslate('Statistics.CanceledCode'))
        this.setState({keySelected: Math.random(),open: false})
      };
      ComparisonCode(code){
        fetch(`/api/comparisonconfirmcode?code=` + code, requestOptionsExit)
        .then((response) => response.json())
        .then((response) => {
                if(response.data == "success"){
                    this.props.ChangeCategory();
                }
                else if(response.error == "error")
                {
                    messageWindow.OpenMessage("error", localization.GetTranslate('Statistics.ComparisonCode'))
                }
                this.setState({key: Math.random(),open: true})
                this.props.OpenMessage()
        })
      };
      handleOpen()
      {
        if(this.state.openDialog == false)
        {
         this.setState({openDialog: true})
        }
      }
      handleClose()
      {
          this.setState({openDialog: false, key: Math.random()})
          this.props.ChangeParamCategory(undefined)
      }
    render()
    {
        const{data} = this.props.res;
        var cardCategory = data.categories;
        var change = data.changeCategory;  
        var confirmSMS = data.useConfirm; 
        var nameCategory = data.nameCategory;
        return(
            <Paper key={this.props.key} className="cardCategoryBox">
                <Label textLabel={localization.GetTranslate('Statistics.Current card category')} className="cardCategoryLabel"></Label>
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label style={{color: themeColorText.color}} 
                        textLabel={nameCategory === "Отсутствует"?localization.GT('Statistics.Absent'):nameCategory} 
                        className="currentcategoryLabel"></Label>
                    </Grid>
                    <Grid hidden={change === true ? "":"hidden"} item xs={"auto"}>
                        <Button
                                onClick={this.handleOpen}
                                variant="contained"
                                type="submit"
                                value="submit"
                                color="primary"
                                disabled={this.props.asyncDisabled}
                                textLabel={localization.GetTranslate('buttons.Change')}
                                className="SaveButtonStats"
                               
                            >
                        </Button> 
                        <Dialog
                            open={this.state.openDialog}
                            scroll={'paper'}
                            aria-labelledby="scroll-dialog-title"
                            aria-describedby="scroll-dialog-description"                      
                        >
                            <DialogTitle id="scroll-dialog-title" align='center' style={{padding: "0px 24px"}} className="DialogTitle">
                                    <CloseIcon style={{position: "absolute", top: 10, right: 15}} onClick={this.handleClose} className="DialogClose"></CloseIcon>
                                    <Label textLabel={localization.GetTranslate('Statistics.AllowChangecategory')} className="cardCategoryLabel"></Label>
                            </DialogTitle>
                            <DialogContent dividers={'paper'} style={{padding: "5px 24px"}} className="DialogContent">
                                <DialogContentText
                                id="scroll-dialog-description"                            
                                tabIndex={-1}
                                align='center'
                                >
                                <ThemeProvider theme={materialThemeField}>
                                <SelectCategory  
                                    style={{color: themeColorText.color}}
                                    key={this.state.keySelected}
                                    id="SelectCategory" 
                                    selected={this.state.selected}
                                    nameCategory={nameCategory} 
                                    cardCategory={cardCategory} 
                                    change={change} 
                                    className="changecategoryValueLabel"
                                    ChangeParamCategory={this.props.ChangeParamCategory}
                                    ></SelectCategory>
                                </ThemeProvider>
                                </DialogContentText>
                            </DialogContent>
                            <DialogActions style={{display:"block"}} className="DialogActions">
                            <div className="BoxSaveButton">
                            <Button
                                variant="contained"
                                type="submit"
                                value="submit"
                                color="primary"
                                textLabel={localization.GetTranslate('buttons.Save')}
                                className="SaveButtonStats"
                                disabled={this.props.param === "defaultCardCategory" | this.props.param === undefined ? true : false}
                                onClick={confirmSMS? this.confirmWindowChangeCategory : this.props.ChangeCategory}
                            >
                            </Button>
                            </div> 
                            </DialogActions>
                        </Dialog> 

                        <FormDialog 
                        open = {this.state.open}
                        handleClose = {this.confirmChangeCategoryClose}
                        comparisonCode = {this.ComparisonCode}
                        title={localization.GetTranslate('Statistics.ConfirmSMS')}
                        ></FormDialog>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}

class ClientCategory extends Component 
{ 
    constructor(props) {
    super(props); 
    this.state = {
    }
}
    render()
    {
        const{data} = this.props.res;
        var nameCategory = data.nameClientCategory;
        return(
            <Paper key={this.props.key} className="cardCategoryBox">
                <Label textLabel={localization.GetTranslate('Statistics.Current card category')} className="cardCategoryLabel"></Label>
                <Grid container justify="center" spacing={1}>
                    <Grid item xs={"auto"}>
                        <Label style={{color: themeColorText.color}} 
                        textLabel={nameCategory === null?localization.GT('Statistics.Absent'):nameCategory} 
                         className="currentcategoryLabel currentclientcategoryLabel"></Label>
                    </Grid>
                </Grid>
            </Paper>
        );
    }
}
class PurchaseAmount extends Component 
{
    render()
    {
        const{data} = this.props.res;
        const{AppliedSettings} = this.props;
        return(
            <div>
            {AppliedSettings.statistics_diagram_table === 0 &&
            <Paper className={AppliedSettings.statistics_barcode !== false? "purchaseAmountBox" : "purchaseAmountBoxBarcodeOFF"}>
                <Label textLabel={localization.GetTranslate('Statistics.Purchase Amount')} className="purchaseAmountLabel"></Label>
                <TablePurchaseAmount data={data} className="purchaseAmountTable"></TablePurchaseAmount>
            </Paper>
            }
            {AppliedSettings.statistics_diagram_table === 1 &&
            <Paper  className="purchaseAmountBox">
                <Label textLabel={localization.GetTranslate('Statistics.Seasoned')} className="purchaseAmountLabel"></Label>
                <TableSeasoned data={data} className="purchaseAmountTable"></TableSeasoned>
            </Paper>
            }
            </div>
        );
    }
}
class Walletbalances extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="discountsBox">
                <Label textLabel={localization.GetTranslate('Statistics.Walletbalances')} className="purchaseAmountLabel"></Label>
                <TableWalletbalances data={data} className="purchaseAmountTable"></TableWalletbalances>
            </Paper>
        );
    }
}
class Seasoned extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper  className="purchaseAmountBoxBarcodeOFF">
                <Label textLabel={localization.GetTranslate('Statistics.Seasoned')} className="purchaseAmountLabel"></Label>
                <TableSeasoned data={data} className="purchaseAmountTable"></TableSeasoned>
            </Paper>
        );
    }
}
class PurchaseAmountIsCompany extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="accommodationCountersBox">
                <Label textLabel={localization.GetTranslate('Statistics.Purchase Amount')} className="accommodationCountersLabel"></Label>
                <TablePurchaseAmountIsCompany data={data} className="accommodationCountersTable"></TablePurchaseAmountIsCompany>
            </Paper>
        );
    }
}
class BonusMonth extends Component 
{
    render()
    {
        const{data} = this.props.diagramstat;
        return(
            <Paper className={this.props.className}>
                    <Label textLabel={localization.GetTranslate('Statistics.Bonuses in recent months')} className="bonusMonthLabel"></Label>
                    <Diagram width={this.props.width} diagramstat={data} className="bonusMonthDiagram" barThickness={this.props.barThickness}></Diagram>
            </Paper>
        );
    }
}
class Barcode extends Component 
{ 
    componentDidMount() {
        JsBarcode(".barcode").init();
      }
    render()
    {  JsBarcode(".barcode").init();
        const{data} = this.props.res;
        var BarCode_Y_N = this.props.AppliedSettings.statistics_barcode;
        
        return(
            <div>
                {BarCode_Y_N &&
                    <Paper style={this.props.style} className={this.props.className}>
                        <Label textLabel={localization.GetTranslate('Statistics.Barcode')} className="barcodeLabel"></Label>  
                        <div className={this.props.isCompany}>      
                            <svg className="barcode" jsbarcode-format={data.Type_Barcode} jsbarcode-value={data.BarCode} jsbarcode-textmargin="0" jsbarcode-height="170" jsbarcode-fontoptions="bold"/>     
                        </div>
                    </Paper>
                }
            </div>
        );
    }
}
class AccommodationCounters extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="accommodationCountersBox">
                <Label textLabel={localization.GetTranslate('Statistics.Accommodation counters')} className="accommodationCountersLabel"></Label>
                <TableAcCounters data={data} className="accommodationCountersTable mobileTable"></TableAcCounters>
            </Paper>
        );
    }
}
class Discounts extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="discountsBox">
                <Label textLabel={localization.GetTranslate('Statistics.Discounts')} className="discountsLabel"></Label>
                <TableDiscounts data={data} className="discountsTable"></TableDiscounts>
            </Paper>
        );
    }
}
class IncomeFundsHistory extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="IncomeHistory">
                <Label textLabel={localization.GetTranslate('Statistics.FundsHistory')} className="IncomeHistoryLabel"></Label>
                <TableFundsHistory AppliedSettings={this.props.AppliedSettings} data={data} className="IncomeHistoryTable"></TableFundsHistory>
            </Paper>
        );
    }
}
class IncomeFuelHistory extends Component 
{
    render()
    {
        const{data} = this.props.res;
        return(
            <Paper className="IncomeHistory">
                <Label textLabel={localization.GetTranslate('Statistics.FuelHistory')} className="IncomeHistoryLabel"></Label>
                <TableFuelHistory AppliedSettings={this.props.AppliedSettings} data={data} className="IncomeHistoryTable"></TableFuelHistory>
            </Paper>
        );
    }
}
export { 
    Bonus,
    BonusByRecallRule,
    PromoCodesList,
    DefaultCard,
    CardCategory, 
    ClientCategory,
    PurchaseAmount, 
    Walletbalances, 
    Seasoned, 
    PurchaseAmountIsCompany, 
    BonusMonth, 
    Barcode, 
    AccommodationCounters, 
    Discounts, 
    IncomeFundsHistory, 
    IncomeFuelHistory
};